import React from 'react';
import { formatCategory } from '../../../utils/format';
import Units from './Units';
import { ProductSearchModal } from '../../../components';
import { thunks } from '../../../redux/modules/appUsers';

export default class Cart extends React.Component {
    state = {
        showModal: false
    }

    removeItem = item => {
        const { loading, dispatch } = this.props
        if (loading) return;

        dispatch(thunks.removeProduct([{
            productId: item.productId,
            units: 0,
        }]))
    }

    onChangeUnits = (type, productId) => {
        const { loading, dispatch } = this.props;
        if (loading) return;

        dispatch(thunks[type === '+' ? 'addProduct' : 'removeProduct']([{
            productId : JSON.stringify(productId),
            units: 1,
        }]))
    }

    toggleProductModal = () => {
        this.setState(state => ({
            showModal: !state.showModal,
        }));
    }

    onSelectProduct = item => {
        this.onChangeUnits('+', item.productId);
        this.toggleProductModal();
    }

    render() {
        const { data } = this.props;
        const { showModal } = this.state;
        return(
            <div className="row">
                <div className="col-md-12 mb-3">
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary" onClick={this.toggleProductModal}>Add Product</button>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Category</th>
                                    <th>Price</th>
                                    <th>Units</th>
                                    <th>Total</th>
                                    <th/>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    (data.items || []).length ? (
                                        data.items.map(item => (
                                            <tr key={item.productId}>
                                                <td>{item.productId}</td>
                                                <td>{item.name}</td>
                                                <td>{formatCategory(item.categoryName)}</td>
                                                <td>{item.price}</td>
                                                <td>
                                                    <Units units={item.units} onChange={this.onChangeUnits} productId={item.productId} removeItem={this.removeItem}/>
                                                </td>
                                                <td>{item.units * item.price}</td>
                                                <td>
                                                    <button title="Remove Item" className="btn btn-xs btn-danger" onClick={() => this.removeItem(item)}>
                                                        <i className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">Cart is empty</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                    {
                        (data.items || []).length ? (
                            <div className="row">
                                <div className="col-md-7"/>
                                <div className="col-md-3">
                                    <div className="d-flex">
                                        <div className="flex-1">
                                            <h5>GST:</h5>
                                        </div>
                                        <div className="flex-1 d-flex justify-content-end">
                                            <h4> {data.gst}</h4>
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="flex-1">
                                            <h4>Total:</h4>
                                        </div>
                                        <div className="flex-1 d-flex justify-content-end">
                                            <h4> {data.totalPrice}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null
                    }
                </div>
                <ProductSearchModal 
                    show={showModal}
                    onHide={this.toggleProductModal}
                    onSelect={this.onSelectProduct}
                />
            </div>
        )
    }
}